import { setBooleanFeatureFlagResolver } from '@atlaskit/platform-feature-flags';
import { fg } from '@atlassian/jira-feature-gating';
import { ff } from '../get-feature-flag-value';

export const initPlatformFeatureFlags = () => {
	setBooleanFeatureFlagResolver((flagKey) => fg(flagKey) || ff(flagKey));
};
